import { render, staticRenderFns } from "./ZnBdFile.vue?vue&type=template&id=67df1bda&"
import script from "./ZnBdFile.vue?vue&type=script&lang=js&"
export * from "./ZnBdFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports